import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'

import './assets/globals.css'
import './assets/formulate.css'
import VueFormulate from '@braid/vue-formulate'

import FormulateVSelectPlugin from '@cone2875/vue-formulate-select'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import vSelect from 'vue-select'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import './directives/outsideClick.js'

import { setApiData, useAuth0 } from './services/api/config.js'
import { default as auth0User } from './services/auth0/user.js'
setApiData(
  window?.CESO_KANAN_DATA?.siteHomeUrl,
  window?.CESO_KANAN_DATA?.apiUrl,
  window?.CESO_KANAN_DATA?.nonce,
  window?.CESO_KANAN_DATA?.hereApiKey,
  window?.CESO_KANAN_DATA?.apiVersion,
)
if (useAuth0()) {
  auth0User.initAuth0()
}
else {
  auth0User.disableService()
}

// Make BootstrapVue available throughout the project
Vue.use(BootstrapVue)

Vue.use(VueAxios, axios)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css'

Vue.use(VueFormulate, {
  // Define our custom slot component(s)
  slotComponents: {},
  // Define any props we want to pass to our slot component
  slotProps: {},
  plugins: [FormulateVSelectPlugin],
})

// Global registration
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap)

Vue.component('v-select', vSelect)

// add more rules to be used globally by the vee-validate functions and components.
extend('secret', {
  validate: value => value === 'example',
  message: 'Global Rule'
})
extend('required', required)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.use(VueRouter)

import Home from './pages/Home.vue'
import NewRequestForm from './pages/NewRequestForm.vue'
import ChangeRequestForm from './pages/ChangeRequestForm.vue'
import StudentHistory from './pages/StudentHistory.vue'
import DailyNoShowForm from './pages/DailyNoShowForm.vue'
import LateRouteForm from './pages/LateRouteForm.vue'
import CalendarEmbed from './pages/CalendarEmbed.vue'
import CalendarForm from './pages/CalendarForm.vue'
import EventList from './pages/CalendarForm/EventList.vue'
import StudentList from './pages/StudentList.vue'
import OneTimeNoRideList from './pages/OneTimeNoRideList.vue'
import DailyNoShowList from './pages/DailyNoShowList.vue'
import RouteDetailPage from './pages/RouteDetailPage.vue'
import CancelForm from './pages/CancelForm.vue'
import OneTimeNoRide from './pages/OneTimeNoRide.vue'
import PageNotFound from './pages/PageNotFound.vue'
import RouteList from './pages/RouteList.vue'
import DriverList from './pages/DriverList.vue'
import DriverForm from './pages/DriverForm.vue'
import VehicleList from './pages/VehicleList.vue'
import VehicleForm from './pages/VehicleForm.vue'
import OneTimeRide from './pages/OneTimeRide.vue'
import UserManagementSync from './pages/UserManagementSync.vue'
import EditContact from './pages/EditContact.vue'

import VendorForms from './pages/VendorForms.vue'
//import PDFViewer from './pages/PDFViewer'

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Home,
    },
    {
      path: '*',
      component: PageNotFound,
      redirect: '/',
    },
    {
      path: '/NewRequestForm',
      name: 'NewRequestForm',
      component: NewRequestForm,
    },
    {
      path: '/ChangeRequestForm',
      name: 'ChangeRequestForm',
      component: ChangeRequestForm,
    },
    {
      path: '/StudentHistory/:dbId',
      name: 'StudentHistory',
      component: StudentHistory,
    },
    {
      path: '/DailyNoShowForm',
      name: 'DailyNoShowForm',
      component: DailyNoShowForm,
    },
    {
      path: '/LateRouteForm',
      name: 'LateRouteForm',
      component: LateRouteForm,
    },
    {
      path: '/CalendarEmbed',
      name: 'CalendarEmbed',
      component: CalendarEmbed,
    },
    {
      path: '/OneTimeNoRide',
      name: 'OneTimeNoRide',
      component: OneTimeNoRide,
      props: true,
    },
    {
      path: '/EventList',
      name: 'EventList',
      component: EventList,
    },
    {
      path: '/CalendarForm/',
      name: 'CalendarForm',
      component: CalendarForm,
      props: true,
    },
    {
      path: '/StudentList',
      name: 'StudentList',
      component: StudentList,
      props: true,
    },
    {
      path: '/CancelForm',
      name: 'CancelForm',
      component: CancelForm,
      props: true,
    },
    {
      path: '/DriverList',
      name: 'DriverList',
      component: DriverList,
      props: true,
    },
    {
      path: '/DriverForm/:id?',
      name: 'DriverForm',
      component: DriverForm,
      props: true,
    },
    {
      path: '/VehicleList',
      name: 'VehicleList',
      component: VehicleList,
      props: true,
    },
    {
      path: '/VehicleForm/:id?',
      name: 'VehicleForm',
      component: VehicleForm,
      props: true,
    },
    {
      path: '/RouteList',
      name: 'RouteList',
      component: RouteList,
      props: true
    },
    {
      path: '/OneTimeNoRideList',
      name: 'OneTimeNoRideList',
      component: OneTimeNoRideList,
      props: true
    },
    {
      path: '/DailyNoShowList',
      name: 'DailyNoShowList',
      component: DailyNoShowList,
      props: true
    },
    {
      path: '/RouteDetail/:id?',
      name: 'RouteDetail',
      component: RouteDetailPage,
      props: true
    },
    {
      path: '/OneTimeRide',
      name: 'OneTimeRide',
      component: OneTimeRide,
      props: true,
    },
    {
      path: '/UserManagementSync',
      name: 'UserManagementSync',
      component: UserManagementSync,
    },

    {
      path: '/VendorForms',
      name: 'VendorForms',
      component: VendorForms,
    },

    {
      path: '/EditContact/:dbId',
      name: 'EditContact',
      component: EditContact,
      props: true,
    },

    // {
    //   path: '/PDFViewer',
    //   name: 'PDFViewer',
    //   component: PDFViewer,
    // }
  ],
})

auth0User.setVueRouter(router)

Vue.config.productionTip = false

new Vue({
  router,
  render: h =>
    h(App, {
      props: {
        siteHomeUrl: window?.CESO_KANAN_DATA?.siteHomeUrl,
        apiUrl: window?.CESO_KANAN_DATA?.apiUrl,
        nonce: window?.CESO_KANAN_DATA?.nonce,
        hereApiKey: window?.CESO_KANAN_DATA?.hereApiKey,
      },
    }),
}).$mount('#app')
